import { DotLegalCheckbox, DotLegalMultiSelect, DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import PaneLayout from "../../../main/panes/paneLayout/PaneLayout";
import { definePane } from "../../../main/panes/definePane";
import { contactTypeOptions, useLegalEntityContactPane } from "./LegalEntityContactPane.hooks";
import { LegalEntityContactPaneProps } from "./LegalEntityContactPane.types";

function LegalEntityContactPane(props: LegalEntityContactPaneProps) {
    const { translateString } = useTranslation();
    const { contact, modelUpdater, onSaveClick, validation, isEdit, isSaving } = useLegalEntityContactPane(props);

    return (
        <PaneLayout
            reserveFieldTooltipSpace
            header={isEdit ? translateString("editContact") : translateString("addContact")}
            okButtonText={translateString("save")}
            onOkClick={onSaveClick}
            inProgress={isSaving}
        >
            <DotLegalTextField
                label={translateString("name")}
                onChange={modelUpdater.onNameChange}
                value={contact.name}
                debounce={false}
                errorText={validation.getErrorsForDisplay("name")}
            />
            <DotLegalTextField
                label={translateString("email")}
                onChange={modelUpdater.onEmailChange}
                value={contact.email}
                debounce={false}
                errorText={validation.getErrorsForDisplay("email")}
            />

            <DotLegalTextField
                label={translateString("phone")}
                onChange={modelUpdater.onPhoneNumberChange}
                value={contact.phoneNumber ?? ""}
                debounce={false}
            />

            <DotLegalMultiSelect
                options={contactTypeOptions(translateString)}
                chosenOptions={contact.contactTypes.map((x) => x.toString())}
                onChange={modelUpdater.onContactTypesChange}
                placeholder={translateString("type")}
                label={translateString("type")}
                noOptionsLabel={translateString("noOptions")}
            />

            <DotLegalCheckbox checked={contact.primaryContact} onChange={modelUpdater.onPrimaryContactChange} label={translateString("primaryContact")} />
        </PaneLayout>
    );
}

export default definePane({ slot: "right", component: LegalEntityContactPane });
